import { createContext } from "react";
const initialState = { toastMaster: {}, toasts: [] }, ToastContext = createContext(initialState);
export {
  ToastContext
};
//# sourceMappingURL=ToastContext.js.map
